import React, { Component } from "react";
import Swiper from "swiper";

export default class PrivacyPolicy extends Component {
  constructor(props) {
    super(props);
    this.state = {
      loading: true,
      isCollapsed: false,
      isMenuOpen: false,
      activeTab: "tab-1",
    };
  }
  setActiveTab = (tabId) => {
    this.setState({ activeTab: tabId });
  };

  closeMenu = (event) => {
    if (!event.target.closest(".dropdown")) {
      this.setState({ isMenuOpen: false });
    }
  };
  toggleMenu = () => {
    this.setState((prevState) => ({
      isMenuOpen: !prevState.isMenuOpen,
    }));
  };
  handleScroll = () => {
    const scrollTop = window.pageYOffset;
    const isCollapsed = scrollTop > 60;
    this.setState({ isCollapsed });
  };
  componentDidMount() {
    setTimeout(() => {
      this.setState({ loading: false });
    }, 500);
    window.addEventListener("scroll", this.handleScroll);
    this.handleScroll();
    document.querySelectorAll("a.page-scroll").forEach((anchor) => {
      anchor.addEventListener("click", this.handleSmoothScroll);
    });

    this.swiper = new Swiper(
      ".image-slider",
      {
        autoplay: {
          delay: 2000,
          disableOnInteraction: false,
        },
        loop: false,
        navigation: {
          nextEl: ".swiper-button-next",
          prevEl: ".swiper-button-prev",
        },
        spaceBetween: 30,
        slidesPerView: 5,
        breakpoints: {
          516: { slidesPerView: 1, spaceBetween: 10 },
          767: { slidesPerView: 2, spaceBetween: 20 },
          991: { slidesPerView: 3, spaceBetween: 30 },
          1199: { slidesPerView: 4, spaceBetween: 30 },
        },
      },
      100
    );
  }

  componentWillUnmount() {
    window.removeEventListener("scroll", this.handleScroll);
    document.querySelectorAll("a.page-scroll").forEach((anchor) => {
      anchor.removeEventListener("click", this.handleSmoothScroll);
    });
  }

  handleSmoothScroll = (event) => {
    event.preventDefault();
    const targetId = event.currentTarget.getAttribute("href").substring(1);
    const targetElement = document.getElementById(targetId);

    if (targetElement) {
      window.scrollTo({
        top: targetElement.offsetTop,
        behavior: "smooth",
      });
    }
  };
  render() {
    const { loading, isCollapsed, isMenuOpen, activeTab } = this.state;

    return (
      <>
        <head>
          <meta charset="utf-8" />
          <meta
            name="viewport"
            content="width=device-width, initial-scale=1, shrink-to-fit=no"
          />

          <title>Privacy Policy - Ut App</title>
          <link
            rel="stylesheet"
            href="https://cdnjs.cloudflare.com/ajax/libs/magnific-popup.js/1.1.0/magnific-popup.min.css"
          />

          <link href="css/styles.css" rel="stylesheet" />

          <script src="https://cdn.jsdelivr.net/npm/validator@0.11.8/dist/validator.min.js"></script>

          <script src="https://cdn.jsdelivr.net/npm/swiper@4.4.6/dist/js/swiper.min.js"></script>
          <link
            rel="stylesheet"
            href="https://cdn.jsdelivr.net/npm/swiper@4.4.6/dist/css/swiper.min.css"
          />
          <link
            href="https://fonts.googleapis.com/css?family=Open+Sans:400,400i,700&display=swap&subset=latin-ext"
            rel="stylesheet"
          />
          <script src="https://code.jquery.com/jquery-3.3.1.slim.min.js"></script>
          <script src="https://cdn.jsdelivr.net/npm/popper.js@1.14.7/dist/umd/popper.min.js"></script>
          <script src="https://cdn.jsdelivr.net/npm/bootstrap@4.3.1/dist/js/bootstrap.min.js"></script>
          <link
            href="https://cdn.jsdelivr.net/npm/bootstrap@4.3.1/dist/css/bootstrap.min.css"
            rel="stylesheet"
          />
          <link
            href="https://cdnjs.cloudflare.com/ajax/libs/font-awesome/5.15.4/css/all.min.css"
            rel="stylesheet"
          />

          <link rel="icon" href="images/logo.png" />
        </head>
        <body data-spy="scroll" data-target=".fixed-top">
          {/* <div className="spinner-wrapper">
            <div className="spinner">
              <div className="bounce1"></div>
              <div className="bounce2"></div>
              <div className="bounce3"></div>
            </div>
          </div> */}

          <nav
            className={`navbar navbar-expand-lg navbar-dark ustmenu-default fixed-top ${
              isCollapsed ? "top-nav-collapse" : ""
            }`}
          >
            <div className="container">
              <a className="navbar-brand logo-image" href="/">
                <img src="images/Universalteam.svg" alt="alternative" />
              </a>

              <button
                className="navbar-toggler"
                type="button"
                onClick={this.toggleMenu}
              >
                <span className="ustmenu-ackapa-fw fas fa-bars"></span>
                {/* <span className="ustmenu-ackapa-fw fas fa-times"></span> */}
              </button>

              <div
                className={`collapse navbar-collapse ${
                  isMenuOpen ? "show" : ""
                }`}
                id="navbarsExampleDefault"
              >
                <ul className="navbar-nav ml-auto">
                  <li className="nav-item dropdown">
                    <a
                      className="nav-link dropdown-toggle page-scroll"
                      id="navbarDropdown"
                      role="button"
                      aria-haspopup="true"
                      aria-expanded="false"
                    >
                      Extra
                    </a>
                    <div
                      className="dropdown-menu"
                      aria-labelledby="navbarDropdown"
                    >
                      <a className="dropdown-item" href="/privacy-policy">
                        <span className="item-text">Privacy Policy</span>
                      </a>
                    </div>
                  </li>
                </ul>
                <span className="nav-item">
                  <a
                    className="buton-cizgili-kucuk page-scroll"
                    href="#download"
                    onClick={this.closeMenu}
                  >
                    DOWNLOAD
                  </a>
                </span>
              </div>
            </div>
          </nav>

          <header id="header" className="ex-header">
            <div className="container">
              <div className="row">
                <div className="col-md-12">
                  <h1>Privacy Policy</h1>
                </div>
              </div>
            </div>
          </header>

          <div className="ex-temel">
            <div className="container">
              <div className="row">
                <div className="col-lg-12">
                  <div className="breadcrumbs">
                    <a href="/">Home</a>
                    <i className="fa fa-angle-double-right"></i>
                    <span>Privacy Policy</span>
                  </div>
                </div>
              </div>
            </div>
          </div>

          <div className="ex-basic-2">
            <div className="container">
              <div className="row">
                <div className="col-lg-12">
                  <div className="metin-kutusu">
                    <h3>Privacy Policy</h3>
                    <p>Privacy policy will be here.</p>
                  </div>

                  <a className="genel-buton-solid" href="index.html">
                    BACK
                  </a>
                </div>
              </div>
            </div>
          </div>
          <div className="ex-temel">
            <div className="container">
              <div className="row">
                <div className="col-lg-12">
                  <div className="breadcrumbs">
                    <a href="/">Home</a>
                    <i className="fa fa-angle-double-right"></i>
                    <span>Privacy Policy</span>
                  </div>
                </div>
              </div>
            </div>
          </div>

          <div className="footer">
            <div className="container">
              <div className="row">
                <div className="col-lg-12">
                  <div className="footer-col first">
                    <h5>About Ut App</h5>
                    <p className="kucuk-baslik">
                      Ut app is designed for team management.
                    </p>
                  </div>
                  <div className="footer-col second">
                    <h5>Contact Info</h5>
                    <ul className="liste-stili li-buyuk-bosluk kucuk-baslik">
                      <li className="media">
                        <i className="fas fa-envelope"></i>
                        <div className="media-body">
                          <a href="">workience@gmail.com</a>
                        </div>
                      </li>
                      <li className="media">
                        <i className="fas fa-phone-alt"></i>
                        <div className="media-body">
                          <a href="">+553 462 20 99</a>
                        </div>
                      </li>
                    </ul>
                  </div>
                  <div className="footer-col third">
                    <h5>Value Links</h5>
                    <ul className="liste-stili li-buyuk-bosluk kucuk-baslik">
                      <li>
                        <a href="/privacy-policy">Privacy Policy</a>
                      </li>
                    </ul>
                  </div>
                  <div className="footer-col fourth">
                    <h5>Other Apps</h5>
                    <ul className="liste-stili li-buyuk-bosluk kucuk-baslik">
                      <li>
                        <a href="">Coming Soon..</a>
                      </li>
                    </ul>
                  </div>
                  <div className="footer-col fifth">
                    <span className="fa-stack">
                      <a href="">
                        <i className="fas fa-circle fa-stack-2x"></i>
                        <i className="fab fa-facebook-f fa-stack-1x"></i>
                      </a>
                    </span>
                    <span className="fa-stack">
                      <a href="">
                        <i className="fas fa-circle fa-stack-2x"></i>
                        <i className="fab fa-twitter fa-stack-1x"></i>
                      </a>
                    </span>
                    <span className="fa-stack">
                      <a href="">
                        <i className="fas fa-circle fa-stack-2x"></i>
                        <i className="fab fa-pinterest-p fa-stack-1x"></i>
                      </a>
                    </span>
                    <span className="fa-stack">
                      <a href="">
                        <i className="fas fa-circle fa-stack-2x"></i>
                        <i className="fab fa-instagram fa-stack-1x"></i>
                      </a>
                    </span>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div className="copyright">
            <div className="container">
              <div className="row">
                <div className="col-lg-12">
                  <p className="kucuk-baslik">
                    Copyright © 2025
                    <a href="https://nmuniversalteam.com"> Universalteam</a> -
                    All rights reserved
                  </p>
                </div>
              </div>
            </div>
          </div>
          <script src="https://cdnjs.cloudflare.com/ajax/libs/jquery/3.6.0/jquery.min.js"></script>
          <script src="https://cdnjs.cloudflare.com/ajax/libs/magnific-popup.js/1.1.0/jquery.magnific-popup.min.js"></script>
          <script src="https://code.jquery.com/jquery-3.6.0.min.js"></script>
          <script src="https://cdnjs.cloudflare.com/ajax/libs/jquery-easing/1.4.1/jquery.easing.min.js"></script>
          <script src="js/scripts.js"></script>
          <script src="https://cdn.jsdelivr.net/npm/@popperjs/core@2.11.6/dist/umd/popper.min.js"></script>
          <script src="https://cdn.jsdelivr.net/npm/swiper@4.4.6/dist/js/swiper.min.js"></script>
        </body>
      </>
    );
  }
}
